// translations.js
export const translations = {
  en: {
    myAccount: 'My Account',
    updateCreditCard: 'Add Credit Card',
    thanks: 'Thanks for choosing Now TV!',
    contactEmail: 'Contact Email',
    addContactEmail: '+ Add a Contact Email',
    change: 'Change',
    email: 'Email',
    updateBillingEmail : 'Also update my billing email',
    errorMessageForInvalidEmail : 'Incorrect email address, Please re-enter.',
    incorrectInfo: 'Your nickname should be under 50 characters in length.',
    save: 'Save',
    cancel: 'Cancel',
    contactMobile: 'Contact Mobile',
    nickname: 'Nickname',
    addNickname: '+ Add a Nickname',
    nowID: 'Now ID',
    emailNowID: 'Email (Now ID)',
    addMobileForLogin: '+ Add Mobile for Login',
    verifyNow: 'Verify now',
    addEmailForLogin: '+ Add Email for Login',
    changeNowIDMobile: 'Change Now ID (Mobile)',
    changeNowIDEmail: 'Change Now ID (Email)',
    password: 'Password',
    changePassword: 'Change Password',
    logout: 'Logout',
    alreadySubscriber: 'Already a subscriber?',
    ensureRightDetails: 'Ensure you\'re seeing the right details',
    findAccountDetails: 'Find My Account Details',
    renewOn: 'Renew on: ',
    cancelRenewal: 'Cancel renewal',
    undefined: 'undefined',
    close: 'Close',
    cancelAutoRenewal: 'Cancel Auto Renewal?',
    validTill: 'Valid till: ',
    note: 'P.S.: Please note that once cancelled, it cannot be undone through the online portal. Any further changes may require contacting our Customer Service hotline at 1833 888.',
    back: 'Back',
    confirm: 'Confirm',
    subscriptionDetailsAndRenewalDates: 'Subscription Details and Renewal Dates',
    combo: 'Combo',
    addonPacks: 'Packs',
    paymentHistory: 'Payment History',
    rental: 'Rental',
    ref: 'Ref:',
    currency: 'HK$',
    communicationPreferences: 'Communication Preferences',
    languagePreferences: 'Language Preferences',
    selectPreferredLanguage: 'Select your preferred language for receiving marketing messages.',
    chinese: 'Chinese',
    english: 'English',
    offersAndPromotions: 'Offers and Promotions',
    optBackIn: 'Opt back in our offers and promotion priority list?',
    yesImIn: 'Yes. I’m in!',
    packMessage: 'This pack will be renewed in the next two days. We require a minimum of two days prior to the renewal date for cancellations. Please contact our Customer Service.',
    chatUs: 'Live Chat',
    OK: 'OK',
    renewNote: '*Please ensure that all changes to the status of your subscription are made at least forty-eight (48) hours prior to the renewal date.',
    cancelNote: 'P.S.: Please note that once cancelled, it cannot be undone through the online portal. Any further changes may require contacting our Customer Service hotline at 1833 888.',
    Cancelled: 'Cancelled',
    BOMBroadband: 'Subscribe via: Netvigator (Please contact Netvigator to cancel/change)',
    NovaXBroadband: 'Subscribe via: Netvigator (Please contact Netvigator to cancel/change)',
    BOMMobile: 'Subscribe via: csl/1O1O (Please contact csl/1O1O to cancel/change)',
    CSTeam: 'Change your mind? Feel free to contact our ',
    CSTeamA: 'CS Team',
    CSTeam2: '.',
    oops: 'Oops',
    inapplicable: 'Inapplicable',
    cash: 'Cash',
    autopay: 'Autopay',
    visa: 'VISA: ',
    master: 'Master: ',
    ae: 'American Express®: ',
    unionpay: 'UnionPay: ',
    paymentMethodHistory: 'Payment Methods & History',
    paymentMethod: 'Payment Method',
    billMedia: 'Bill Media',
    seeDetails: 'See details',
    latestBills: 'Latest Bills',
    paymentMethodRemark1part1: 'If you need information about your previous bills, please ',
    paymentMethodRemark1part2: 'contact our Customer Support',
    paymentMethodRemark1part3: '.',
    paymentMethodRemark2part1: 'For information on earlier bills, please ',
    paymentMethodRemark2part2: 'contact our Customer Support',
    paymentMethodRemark2part3: '.',
    currentOutstandingBalance: 'Current Outstanding Balance',
    netflixSubject: 'Watch TV shows, movies and original series recommended just for you!',
    netflixSubject2: 'Anytime, Anywhere',
    netflixActiviateAccountRemark: 'Login Now ID to activate your Netflix account / Forgot Netflix login',
    activiateAccount: 'Activate / Forgot Netflix login',
    forgotNetflixLogin: 'Get Service Code and Contact Netflix',
    netflixNoBundle: 'Sorry! we couldn’t find any Netflix subscription within your account.',
    subscribeNow: 'Contact Now TV sales representative',
    seeMore: 'See more',
    netflixActivated:'Your account has been activated successfully. If you have forgotten your Netflix account, please get service code and contact Netflix CS team.​',
    netflixNotActivated: 'Your Netflix account has not been activated yet. Please click the button below to proceed with the activation process.',
    netflixActivateNowRemark: 'You will be redirected to Netflix website once clicked the button.',
    netflixActivateNow: 'Activate Netflix account now',
    netflixSubjectGreeting: 'Hi, ',
    netflixSubjectGreeting2: '!',
    netflixNoBundleP: 'Sorry! we couldn’t find any Netflix subscription within your account.',
    netflixNoBundleP2: 'Please contact Now TV sales representative for more details.',
    netflixErrorP: 'Apologies, but it seems that an error has occurred. We are unable to retrieve the information at the moment.',
    netflixErrorP2: 'Please contact Now TV customer support or try again later.',
    accountDeletion: 'Account Deletion',
    deleteNowID: 'Delete Now ID',
    contactEmailError: 'Something went wrong.',
    contactEmailError2: 'Please try again.',
    accountnSubscriptions: 'Account & Subscriptions',
    accountNumber: 'Account Number',
    seeSubscriptionsDetailsAndRenewalDates: 'See Subscriptions Details and Renewal Dates',
    noRecordFound: 'No record found.',
    manageDevices: 'Manage Devices',
    manageDevicesDesc1: 'Devices you had watched with are registered below. You can include up to 5 devices at a time, and concurrently stream or download from up to 2 of those.',
    manageDevicesDesc2: 'You can change devices up to 12 times a year. ',
    remainChanges: 'Remaining changes:',
    remainChangesTimes: '',
    renews: 'Renews:',
    thisDevice: 'This device',
    learnMore: 'Learn More',
    remove: 'Remove',
    devices: 'Devices',
    confirmRemove: 'Confirm to Remove?',
    confirmRemoveDesc: 'Are you sure you want to remove the device ',
    confirmRemoveDesc2: '?',
    removeDevice: 'Remove Device',
    noDevice: 'No device has started watching yet.',
    firstWatching: 'First watching:',
    errorMessageSystemBusy: 'Sorry! Something\'s not working quite right. Please try again.',
    deviceChangeLimit: 'Oops. Device change limit reached! ',
    deviceChangeLimit2: 'You’ve changed devices 12 times in a year. No further device removals until the renewal date. ',
    errorOpps: 'Oops!',
    errorOccurred: 'An error occurred while updating your credit card information.',
    pleaseTryAgainLater: 'Please try again later.',
    backToMyAccount: 'Back to My Account',
    needHelp: 'Need Help?',
    chatWithUs: 'Chat with us',
    maxActiviateMaxAccount: 'Activate HBO Max Account',
    maxLogin: 'Login',
    maxHavenGotNowID: 'Haven’t got a Now ID yet or not sure?',
    maxSetupLinkNowID: 'Setup or Link a Now ID',
    maxDetailProcedure: 'Detail Procedure',
    maxTabH1H2: 'H1 / H2 ',
    maxSetTopBox: 'Set Top Box',
    maxTabOtherBox: 'Other Now TV Boxes',
    maxTabOtherBoxSpan: '',
    maxTabNonSTB: 'Non Set Top ',
    maxBoxUser: 'Box User',
    maxNotSureModel: 'Not sure what model your box is?',
    maxH1BoxTitle: 'Now H1 Box',
    maxH1BoxDesc: 'Green LED light at the front and orange rubber ring at the base',
    maxH2BoxTitle: 'Now H2 Box',
    maxH2BoxDesc: 'Power button at the top',
    maxHaveDiffBox: 'Have a different Now TV box than these two?',
    maxMoreEntApp: 'For More Entertainment, Sports, and News, Get Now TV App',
    maxOnMobileDevice: 'On Mobile Device',
    maxOnSmartTV: 'On Smart TV',
    maxStepH1H2_1_1: 'On H1 / H2 set-top-box → Go to HBO Max catalogue → Choose ',
    maxStepH1H2_1_bold: 'Open App',
    maxStepH1H2_1_2: '.',
    maxStepH1H2_2: 'The pre-installed HBO Max app will open. Follow instructions in the app to setup your HBO Max account.',
    maxStepH1H2_3: 'Once completed, you may start streaming from there.',
    maxStepH1H2_4_1: 'From then on, you can open the HBO Max App in the ',
    maxStepH1H2_4_bold: 'Featured apps',
    maxStepH1H2_4_2: ' section on your Now TV set-top-box.',
    maxStepH1H2_4_3: 'Furthermore, you can also:',
    maxStepOther_1: 'On set-top-box → Choose the HBO Max catalogue',
    maxStepOther_2: 'Scan the pop-up QR code. On the page opens on your phone, click “Activate HBO Max”.',
    maxStepOther_NonSTB_3: 'The HBO Max website will open. Follow instructions there to setup your HBO Max account.',
    maxStepNonSTB_1_prefix: '',
    maxStepNonSTB_1_suffix: ' with your Now ID.',
    maxStepNonSTB_2: 'After logged in, click “Activate HBO Max”',
    maxSubject: 'You can enjoy the HBO Max App by activating your HBO Max account. To activate HBO Max, you are required to complete account registration on HBO Max.',
    maxActiviateAccountRemark: 'Login Now ID first and then activate your HBO Max account',
    activiateMaxAccount: 'Activate HBO Max account',
    backToHome: 'Back To Home',
    maxActivated:'Your HBO Max account has already been activated.​',
    maxNotActivated: 'Your HBO Max account has not been activated yet. To activate HBO Max App, you are required to complete account registration on HBO Max.',
    maxRedirectToMaxRemark: 'You will be redirected to HBO Max once clicked the button.',
    maxSubjectGreeting: 'Hi, ',
    maxSubjectGreeting2: '!',
    maxErrorP: 'Apologies, seems there is an error. We are unable to retrieve the information at the moment.',
    maxErrorP2: 'Please try again later.',
    activateNow: 'Activate Now',
    maxActivateNowRemark: 'You will be redirected to HBO Max website upon clicking “Activate Now”.',
    maxErrorMessage1: 'Temporarily unable to retrieve HBO Max\'s status. Please ',
    maxErrorMessage2: 'click here',
    maxErrorMessage3: ' to refresh the page.',
    maxNowEUser: 'Now E user?',
    maxHeroDesc: 'Unlock incredible possibilities of the HBO Max App. Activate your HBO Max account now!',
    maxNotSureHow: 'Not sure how to do? ',
    maxCheckOutTutorial: 'Check out our HBO Max activation tutorial video',
    maxLearnMore1: ' ',
    maxLearnMore2: 'Learn more here',
    maxLearnMore3: ' about your HBO Max account activation',
    maxActivationGuideTitle: 'HBO Max Activation Guide',
    maxStep1: '1. Click on <br />“Activate Now”.',
    maxStep2: '2. Log in to your Now ID. If you do not have one, set up a new account.',
    maxStep3: '3. Click on the “Activate HBO Max” option to activate your HBO Max app service.',
    maxStep4: '4. Continue to the account setup on the HBO Max website and follow their instructions.',
    maxStep5: '5. Once completed, you are all set to start streaming exclusive content on the HBO Max app!',
    maxBrandingText: 'Dive into the worlds of HBO, Harry Potter, the DC Universe, Cartoon Network, Warner Bros, and Discovery with HBO Max on Now TV.',
    maxLearnMoreHere: 'Learn more here',
    maxAboutYourMaxAccountActivation: ' about your HBO Max account activation.',
    maxSubscriptionNotFound: 'Subscription Not Found',
    maxLoggedInWithNowID: 'Logged in with Now ID:',
    maxNoSubscription: 'We can’t find the HBO Max subscription on this account. Please choose one of the options below to fix this:',
    maxOptionTitle1: 'Have a Now TV Box?',
    maxOptionContent1: 'Link Now ID to your Now TV box​',
    maxOptionTitle2: 'Customer without a Now TV Set-Top Box',
    maxOptionContent2: 'Log in with another Now ID​',
    maxContactUs: 'Contact us for more information',
    maxSubscribeOnline: 'Subscribe Online',
    maxWhatsAppEnquiry: 'WhatsApp Enquiry',
    maxCall: 'Call 2888 0008',
    maxDial: 'Dial 2',
    maxOnceCompleted: 'Once completed, you can:',
    maxDownloadAndWatch: 'Download and Watch on HBO Max App',
    maxAvailableDevices: 'Available on mobile phone, tablet, and Smart TV.',
    maxDetailOnSupportedDevices: 'Detail on supported devices',
    maxSmallNote: 'This link is leading to a 3rd-party website. Now TV does not endorse or guarantee the respective content, products, or services.',
    stbMaxLinkExpired: 'Link expired',
    stbMaxLinkExpiredMessage: 'Please return to your TV, reopen the QR code, and scan it again.',
    stbMaxErrorTitle: 'Something went wrong…',
    stbMaxErrorContent: 'We couldn’t retrieve your details due to an unexpected error. Please return to your TV, reopen the QR code, and try scanning it again.',
    stbMaxNotActivatedTitle: 'Procced to HBO Max Now',
    stbMaxActivated: 'Your HBO Max Account is Now Active!',
    stbMaxActivatedMessage: "You’re all set. Head over to HBO Max to start watching.",
    stbMaxStartWatching: 'Start Watching',
    netflixActivateNowRemark2: 'You will be redirected to Netflix website upon clicking “Activate Now”.',
    netflixErrorMessageP1: 'Temporarily unable to retrieve Netflix\'s status. Please ',
    netflixErrorMessageP2: 'click here',
    netflixErrorMessageP3: ' to refresh the page.',
    activiateDisneyplusAccount: 'Activate Disney+ service',
    disneyplusSubject: 'You can enjoy the Disney+ App by activating your Disney+ service. To activate the Disney+ service, you are required to complete a Disney+ account registration on the Disney+ website.',
    disneyplusSubjectGreeting: 'Hi, ',
    disneyplusSubjectGreeting2: '!',
    disneyplusNoBundle: 'Sorry! We could not find any relevant subscription with your account.',
    disneyplusNotSubscribedYet: 'Not subscribed yet?',
    disneyplusNeedHelp: 'Need help?',
    learnMoreAboutDisneyplusPlans: 'Learn more about Disney+ plans',
    disneyplusActivated:'Your Disney+ service has already been activated.​',
    disneyplusNotActivated: 'Your Disney+ service has not been activated yet. To activate the Disney+ service, you are required to complete a Disney+ account registration on the Disney+ website.',
    disneyplusRedirectRemark: 'You will be redirected to the Disney+ website upon clicking the button.',
    disneyplusStartStreaming: 'Start streaming',
    disneyplusErrorP: 'Apologies, seems there is an error. We are unable to retrieve the information at the moment.',
    disneyplusErrorP2: 'Please try again later.',
    disneyplusActivateNowRemark: 'You will be redirected to Disney+ website upon clicking “Activate Now”.',
    disneyplusErrorMessage1: 'Temporarily unable to retrieve Disney+\'s status. Please ',
    disneyplusErrorMessage2: 'click here',
    disneyplusErrorMessage3: ' to refresh the page.',
    disneyplusSubscriberId: 'Disney+ Subscriber ID: ',
    onDemandCatalogs: 'On Demand Catalogs',
    channels: 'Channels',
    ch: 'CH',
    vas: 'Value Added Services',
    expires: 'Expires',
    changeBillSettings: 'Change Bill Settings',
    billingPreference: 'Billing Preference',
    billingEmailAddress: 'Billing Email Address',
    billingEmailNotice: 'This email address will receive important billing notifications, non-payment notices, and suspension or termination notices.',
    billingEmailAddressPlaceholder: 'Billing Email Address',
    alsoUpdateContactEmail: 'Also update my contact email',
    receiveBillsVia: 'Receive bills via',
    billMediaEmail: 'Email',
    billMediaPaper: 'Postal mail',
    billMediaEmailAndPaper: 'Email and Postal mail',
    billMediaFeeNotice: 'Handling fee may apply for postal mail. For details, please contact Now TV Customer Hotline at 1833 888.',
    billMediaPostalMailContact: 'To choose postal mail, please contact Now TV Customer Hotline at 1833 888. Handling fee may apply.',
    updateBillMediaError: 'Unable to update billing settings. Please try again.',
  },
  zh: {
    myAccount: '我的賬戶',
    updateCreditCard: '新增信用卡',
    thanks: '多謝您選用Now TV!',
    contactEmail: '聯絡電郵',
    addContactEmail: '+ 新增聯絡電郵',
    change: '更改',
    email: '電郵',
    updateBillingEmail : '同時更改我的賬單電郵',
    errorMessageForInvalidEmail : '您所輸入之電郵地址不正確，請重新輸入',
    incorrectInfo: '你的暱稱長度必須為50個字元之內',
    save: '儲存',
    cancel: '取消',
    contactMobile: '流動電話',
    nickname: '暱稱',
    addNickname: '+ 您的暱稱',
    nowID: 'Now ID',
    emailNowID: '電郵地址 (Now ID)',
    addMobileForLogin: '+ 您的流動電話號碼作為登入帳號',
    verifyNow: '立即驗證',
    addEmailForLogin: '+ 您的電郵地址作為登入帳號',
    changeNowIDMobile: '更改 Now ID（流動電話）',
    changeNowIDEmail: '更改 Now ID（電郵）',
    password: '密碼',
    changePassword: '更改密碼',
    logout: '登出',
    alreadySubscriber: '已成為 Now TV 客戶？',
    ensureRightDetails: '請確定您的資料正確',
    findAccountDetails: '配對我的賬戶資料',
    renewOn: '續訂日期： ',
    cancelRenewal: '取消續訂',
    undefined: '未定義',
    close: '關閉',
    cancelAutoRenewal: '取消自動續訂？',
    validTill: '有效期至： ',
    note: '註：請注意，一旦確認了取消續訂，將無法透過線上系統撤回。如有任何更改，請致電我們的客戶服務熱線 1833 888。',
    back: '返回',
    confirm: '確認',
    subscriptionDetailsAndRenewalDates: '訂購詳情及續訂日期',
    combo: '精選組合',
    addonPacks: '組合',
    paymentHistory: '付款紀錄',
    rental: '電影租看服務',
    ref: '參考編號：',
    currency: '港幣$',
    communicationPreferences: '通訊語言設定',
    languagePreferences: '語言設定',
    selectPreferredLanguage: '選擇您偏好的語言，收取相關市場推廣信息。',
    chinese: '中文',
    english: '英文',
    offersAndPromotions: '優惠及推廣資訊',
    optBackIn: '接收優惠及推廣資訊？',
    yesImIn: '同意',
    packMessage: '此組合將於這兩天內自動續訂。客戶須於續訂日期不少於兩天前進行取消續訂。請聯絡我們的客戶服務，以尋求協助。',
    chatUs: '線上對話',
    OK: '確定',
    renewNote: '*請確保所有有關訂購狀態之變更須於續訂日期不少於四十八 (48) 小時前進行。',
    cancelNote: '註：請注意，一旦確認了取消續訂，將無法透過線上系統撤回。如有任何更改，請致電我們的客戶服務熱線 1833 888。',
    Cancelled: '已取消續訂',
    NovaXBroadband: '訂購於：網上行（如欲取消／更改訂購，請與網上行聯絡）',
    BOMBroadband: '訂購於：網上行（如欲取消／更改訂購，請與網上行聯絡）',
    BOMMobile: '訂購於：csl／1O1O（如欲取消／更改訂購，請與csl／1O1O聯絡）',
    CSTeam: '改變主意？ 請隨時聯絡我們的',
    CSTeamA: '客戶服務',
    CSTeam2: '團隊。',
    oops: '抱歉',
    inapplicable: '不適用',
    cash: '現金',
    autopay: '自動轉賬',
    visa: 'VISA: ',
    master: 'Master: ',
    ae: '美國運通信用卡：',
    unionpay: '銀聯信用卡：',
    paymentMethodHistory: '付款方法及付款紀錄',
    paymentMethod: '付款方法',
    billMedia: '賬單發送方式',
    seeDetails: '查看更多',
    latestBills: '最近賬單',
    paymentMethodRemark1part1: '如果您需要查閱之前的帳單資料，請',
    paymentMethodRemark1part2: '聯絡我們的客戶服務',
    paymentMethodRemark1part3: '。',
    paymentMethodRemark2part1: '有關較早前帳單的信息，請',
    paymentMethodRemark2part2: '聯絡我們的客戶服務',
    paymentMethodRemark2part3: '。',
    currentOutstandingBalance: '現時賬戶結餘',
    netflixSubject: '讓您隨時隨地觀賞優質電視節目、電影及原創系列，體驗個人化的娛樂享受！',
    netflixSubject2: '',
    netflixActiviateAccountRemark: '登入Now ID並啟動Netflix帳號 / 忘記Netflix登入帳戶',
    activiateAccount: '啟動 / 忘記Netflix帳戶',
    forgotNetflixLogin: '獲得服務代碼並聯絡​Netflix',
    netflixNoBundle: '抱歉，我們未能在您的帳戶中找到Netflix訂購記錄。',
    subscribeNow: '聯繫 Now TV 銷售人員',
    seeMore: '更多',
    netflixActivated:'您的帳戶已成功啟動。如果您忘記了您的Netflix帳戶，請獲得服務代碼並聯絡​Netflix。',
    netflixNotActivated: '您的Netflix帳戶尚未啟動。請點擊以下連結以繼續啟動程序。',
    netflixActivateNowRemark: '點擊以下按鈕後，您將會前往Netflix網站。',
    netflixActivateNow: '立即啟動Netflix帳號',
    netflixSubjectGreeting: '您好，',
    netflixSubjectGreeting2: '！',
    netflixNoBundleP: '抱歉，我們未能在您的帳戶中找到Netflix訂購記錄。',
    netflixNoBundleP2: '請聯繫 Now TV 銷售人員以獲取更多詳情。',
    netflixErrorP: '抱歉，似乎發生了一點錯誤，目前無法檢索此頁面的資訊。',
    netflixErrorP2: '請聯繫 Now TV 客戶服務團隊或稍後重試。',
    accountDeletion: '刪除帳戶',
    deleteNowID: '刪除Now ID',
    contactEmailError: '抱歉',
    contactEmailError2: '發生錯誤，請重試。',
    accountnSubscriptions: '賬戶及訂購資料',
    accountNumber: '賬戶號碼',
    seeSubscriptionsDetailsAndRenewalDates: '查看訂購詳情及續訂日期',
    noRecordFound: '未找到任何紀錄。',
    manageDevices: '裝置管理',
    manageDevicesDesc1: '您觀看過的裝置已登記如下。您最多可同時登記 5 部裝置，並可於 2 部裝置同時觀看或下載串流影片。',
    manageDevicesDesc2: '每年您可以轉換裝置的次數上限為 12 次。',
    remainChanges: '轉換裝置次數尚餘：',
    remainChangesTimes: '次',
    renews: '重置日期：',
    thisDevice: '此裝置',
    learnMore: '了解更多',
    remove: '移除',
    devices: '裝置',
    confirmRemove: '確認移除？',
    confirmRemoveDesc: '您確認要移除',
    confirmRemoveDesc2: '裝置嗎？',
    removeDevice: '移除裝置',
    noDevice: '尚未有裝置進行首次觀看。',
    firstWatching: '首次觀看：',
    errorMessageSystemBusy: '抱歉！系統現正繁忙，請稍後再試。',
    deviceChangeLimit: '抱歉！轉換裝置次數已達上限。',
    deviceChangeLimit2: '您於一年內已轉換裝置 12 次。在重置日期之前，您不得移除任何裝置。',
    errorOpps: '噢!',
    errorOccurred: '不好意思，在更新您的信用卡資訊時發生錯誤。',
    pleaseTryAgainLater: '請稍後再試。',
    backToMyAccount: '返回我的帳戶',
    needHelp: '需要幫忙？',
    chatWithUs: '線上對話',
    maxActiviateMaxAccount: '啟動HBO Max帳戶',
    maxLogin: '登入',
    maxHavenGotNowID: '還未擁有Now ID 或不確定?',
    maxSetupLinkNowID: '設定或連結 Now ID',
    maxDetailProcedure: '詳細教學',
    maxTabH1H2: 'H1 / H2 ',
    maxSetTopBox: '機頂盒',
    maxTabOtherBox: '其他 Now TV ',
    maxTabOtherBoxSpan: '機頂盒',
    maxTabNonSTB: '非機頂盒',
    maxBoxUser: '用戶',
    maxNotSureModel: '不確定你的機頂盒型號?',
    maxH1BoxTitle: 'Now H1 機頂盒',
    maxH1BoxDesc: '啟動後，前置面板會亮起綠色LED燈。而此款機項盒的底部為橙色(如圖)。',
    maxH2BoxTitle: 'Now H2 機頂盒',
    maxH2BoxDesc: '頂部設有一個「電源」按鈕。',
    maxHaveDiffBox: '你的 Now TV 機頂盒不是以上兩款?',
    maxMoreEntApp: '更多娛樂、體育及新聞內容，立即下載 Now TV 應用程式',
    maxOnMobileDevice: '流動裝置',
    maxOnSmartTV: '智能電視',
    maxStepH1H2_1_1: '在 H1 / H2 機頂盒介面 → 前往 HBO Max 目錄 → 選擇「開啟應用程式」。',
    maxStepH1H2_1_bold: '',
    maxStepH1H2_1_2: '',
    maxStepH1H2_2: '預載的 HBO Max 應用程式將會開啟。按照應用程式內的指示設定你的 HBO Max 帳戶。',
    maxStepH1H2_3: '完成後，即可開始串流觀看。',
    maxStepH1H2_4_1: '此後，你可在 Now TV 機頂盒的「精選應用程式」區域開啟 HBO Max 應用程式。',
    maxStepH1H2_4_bold: '',
    maxStepH1H2_4_2: '',
    maxStepH1H2_4_3: '此外，你亦可以：',
    maxStepOther_1: '在機頂盒介面 → 選擇 HBO Max 目錄',
    maxStepOther_2: '用手機掃描彈出的二維碼，於手機開啟的網頁上點擊「啟動 HBO Max」。',
    maxStepOther_NonSTB_3: 'HBO Max 網站將會開啟。按照網站上的指示設定你的 HBO Max 帳戶。',
    maxStepNonSTB_1_prefix: '使用你的 Now ID ',
    maxStepNonSTB_1_suffix: '。',
    maxStepNonSTB_2: '登入後，點擊「啟動 HBO Max」',
    maxSubject: '您可以在啟動您的 HBO Max 帳戶後於HBO Max 應用程式中觀賞精彩節目。您需要在HBO Max頁面完成HBO Max帳戶登記，以啟動HBO Max帳戶。',
    maxActiviateAccountRemark: '請先登入您的Now ID，然後啟動您的 HBO Max 帳號。',
    activiateMaxAccount: '啟動HBO Max帳戶',
    backToHome: '返回首頁',
    maxActivated:'您的HBO Max帳戶已成功啟動。​',
    maxNotActivated: '您的HBO Max帳戶尚未啟動。您需要在HBO Max頁面完成HBO Max帳戶登記，以啟動HBO Max應用程式帳戶。',
    maxRedirectToMaxRemark: '點擊以下按鈕後，您將會前往HBO Max。',
    maxSubjectGreeting: '您好，',
    maxSubjectGreeting2: '！',
    maxErrorP: '抱歉，似乎發生了一點錯誤，目前無法檢索此頁面的資訊。',
    maxErrorP2: '請稍後重試。',
    activateNow: '立即啟動',
    maxActivateNowRemark: '點擊「立即啟動」後，您將會前往HBO Max網站。',
    maxErrorMessage1: '目前無法檢索 HBO Max 的狀態。請',
    maxErrorMessage2: '點擊這裡',
    maxErrorMessage3: '以重新整理頁面。',
    maxNowEUser: 'Now E 用戶？',
    maxHeroDesc: '立即啟動你的 HBO Max 賬戶，體驗 HBO Max 應用程式帶來的極致娛樂體驗！',
    maxNotSureHow: '遇到問題？',
    maxCheckOutTutorial: '觀看我們的 HBO Max 啟動程序教學',
    maxLearnMore1: '請',
    maxLearnMore2: '按此',
    maxLearnMore3: '了解更多有關啟動 HBO Max 帳戶之詳情。',
    maxActivationGuideTitle: 'HBO Max啟動程序教學',
    maxStep1: '1. 按「立即啟動」',
    maxStep2: '2. 登入您的Now ID或登記一個全新的Now ID',
    maxStep3: '3. 成功登入/登記後，點擊「啟動HBO Max帳戶」啟動您的HBO Max 應用程式服務',
    maxStep4: '4. 前往HBO Max 網站並按指示完成創建HBO Max賬戶',
    maxStep5: '5. 完成以上簡單步驟，即可觀看 HBO Max 應用程式獨家內容！',
    maxBrandingText: '盡情於Now TV上 投入 HBO、哈利波特、DC宇宙、卡通頻道、華納兄弟、Discovery頻道等經典又精彩的 HBO Max 影視世界。',
    maxLearnMoreHere: '請按此處',
    maxAboutYourMaxAccountActivation: '查閱更多有關啟動 HBO Max 帳戶之詳情。',
    maxSubscriptionNotFound: '找不到相關訂購',
    maxLoggedInWithNowID: '已登入Now ID:',
    maxNoSubscription: '我們在此賬戶中找不到HBO Max的相關訂購，請選擇以下一個選項繼續:',
    maxOptionTitle1: 'Now TV 機頂盒用戶?',
    maxOptionContent1: '將 Now ID 綁定你的機頂盒​',
    maxOptionTitle2: '不連機頂盒用戶​',
    maxOptionContent2: '以另一個 Now ID 登入​',
    maxContactUs: '聯絡我們以了解更多',
    maxSubscribeOnline: '網上訂購',
    maxWhatsAppEnquiry: 'WhatsApp 查詢',
    maxCall: '即打2888 1888',
    maxDial: '按2',
    maxOnceCompleted: '完成啟動後，您可以：',
    maxDownloadAndWatch: '下載並透過 HBO Max 應用程式觀看内容',
    maxAvailableDevices: '適用於手機、平板電腦及智能電視。',
    maxDetailOnSupportedDevices: '支援HBO Max 的裝置詳情',
    maxSmallNote: '您即將離開 Now TV 應用程式並前往第三方應用程式。Now TV 並不會就第三方所提供的內容、產品或服務作出任何認可、保證或承擔任何責任。',
    stbMaxLinkExpired: '連結已過期',
    stbMaxLinkExpiredMessage: '請返回電視畫面，重新開啟並掃描二維碼。',
    stbMaxErrorTitle: '發生錯誤…',
    stbMaxErrorContent: '無法讀取你的資料。請返回電視畫面，重新開啟並掃描二維碼。',
    stbMaxNotActivatedTitle: '立即前往 HBO Max',
    stbMaxActivated: '您的HBO Max 賬戶已成功啟動！',
    stbMaxActivatedMessage: "一切已準備就緒！請前往 HBO Max 開始觀看。",
    stbMaxStartWatching: '立即觀看',
    netflixActivateNowRemark2: '點擊「立即啟動」後，您將會前往Netflix網站。',
    netflixErrorMessageP1: '目前無法檢索 Netflix 的狀態。請',
    netflixErrorMessageP2: '點擊這裡',
    netflixErrorMessageP3: '以重新整理頁面。',
    activiateDisneyplusAccount: '啟動 Disney+ 服務',
    disneyplusSubject: '您可以在啟動您的 Disney+ 服務後於 Disney+ 應用程式中觀賞精彩節目。您需要在 Disney+ 頁面完成 Disney+ 帳戶登記，以啟動 Disney+ 服務。',
    disneyplusSubjectGreeting: '您好，',
    disneyplusSubjectGreeting2: '！',
    disneyplusNoBundle: '抱歉！我們在您的帳戶中找不到任何相關訂閱。',
    disneyplusNotSubscribedYet: '尚未訂閱 Disney+？',
    disneyplusNeedHelp: '需要幫忙？',
    learnMoreAboutDisneyplusPlans: '了解更多關於 Disney+ 服務計劃',
    disneyplusActivated:'您的 Disney+ 服務已成功啟動。​',
    disneyplusNotActivated: '您的 Disney+ 服務尚未啟動。您需要在Disney+ 頁面完成 Disney+ 帳戶登記，以啟動 Disney+ 服務。',
    disneyplusRedirectRemark: '點擊以下按鈕後，您將會前往 Disney+ 網站。',
    disneyplusStartStreaming: '開始觀看',
    disneyplusErrorP: '抱歉，似乎發生了一點錯誤，目前無法獲取相關資訊。',
    disneyplusErrorP2: '請稍後重試。',
    disneyplusActivateNowRemark: '點擊「立即啟動」後，您將會前往Disney+網站。',
    disneyplusErrorMessage1: '目前無法檢索 Disney+ 的狀態。請',
    disneyplusErrorMessage2: '點擊這裡',
    disneyplusErrorMessage3: '以重新整理頁面。',
    disneyplusSubscriberId: 'Disney+ 訂閱用戶 ID: ',
    onDemandCatalogs: '自選服務',
    channels: '頻道',
    ch: '頻道',
    vas: '增值服務',
    expires: '到期日',
    changeBillSettings: '更改賬單設定',
    billingPreference: '賬單偏好',
    billingEmailAddress: '賬單郵寄地址',
    billingEmailNotice: '此電子郵件地址將接收重要的賬單通知，未付款通知以及服務暫停或終止通知。',
    billingEmailAddressPlaceholder: '賬單電郵地址',
    alsoUpdateContactEmail: '同時更改我的聯絡電郵',
    receiveBillsVia: '透過以下方式接收帳單',
    billMediaEmail: '電郵',
    billMediaPaper: '郵寄郵件',
    billMediaEmailAndPaper: '電子郵件和郵寄郵件',
    billMediaFeeNotice: '郵寄方式可能會收取相關手續費。詳情請聯絡Now TV客戶服務熱線1833 888。',
    billMediaPostalMailContact: '如選擇郵寄，請聯絡Now TV客戶服務熱線1833 888。可能需收取相關手續費。',
    updateBillMediaError: '帳單設定無法更新, 請稍後再試。',
  },
  _ch: {}
};
translations._ch = translations.zh;
